module.exports = __webpack_public_path__ + "img/posgraduacao-emeducacao.549efa07.png";